module.exports = __webpack_public_path__ + "static/media/genlinkApp.51ecf1c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/genlinkApp.jpg
// module id = 369
// module chunks = 0